import React, { useContext } from 'react'
import { ReactComponent as Info } from './icons/info.svg'
import { getPackageName } from '../../../../../helpers/packages'
import { formatPrice } from '../../../../../helpers/price'
import { AppConfigContext } from '../../../../../context/AppConfig'
import { variants } from '../../../../../constants/variant'
import { eventBus } from '../../../../../helpers/events'
import { isStagedWithCortPackage } from '../../../../../helpers/packages'
function Package({ className = '', pack, onClick, isActive, onInfoModalShow, id, minimal }) {
  const { isSWApp, isEWApp, isSFApp, show_package_price, hide_prices, isBrodskyApp } = useContext(AppConfigContext)

  function onPackageClick(e) {
    onClick(e)
    if(isActive){
      eventBus.dispatch('packageSelected', {
        package: pack,
      })
    }
  }


  return (
    <button
      {...(id ? { id } : {})}
      onClick={onPackageClick}
      className={`relative font-medium px-[12px] cursor-pointer w-full lg:w-max shrink-0 py-[8px] ${
        minimal ? 'h-[40px]' : ''
      } flex justify-center border-solid border-[#3d42562f] flex-col ${
        !minimal && !hide_prices ? 'pr-[30px]' : ''
      } lg:border-r-[1px] lg:last:border-r-0  ${
        isActive
          ? `${isSFApp ? 'bg-black text-white' : isStagedWithCortPackage(pack) ? 'bg-[#DA2F3C]' : 'bg-white'}`
          : `${isSFApp ? 'bg-black' : 'hover:bg-[#fafafa] bg-[#F5F5F5] z-[50]'}`
      } ${pack.border ? '' : 'border-transparent'} ${className}`}
    >
      {!minimal && (
        <div className={`${isActive ? '' : 'opacity-60'} w-full`}>
          <div
            title={getPackageName(pack)}
            className={`${
              isActive
                ? isSFApp
                  ? 'text-[#B7BECE]'
                  : 'text-[var(--brand-color)]'
                : `${isSFApp ? 'text-white' : 'text-[#3D4256]'}`
            } truncate lg:w-full ${hide_prices ? 'text-center' : 'text-left'}`}
          >
            {getPackageName(pack)}
          </div>
          {!isEWApp && (
            <div
              className={`text-[12px] text-left font-medium truncate ${
                isSWApp || isBrodskyApp || isSFApp ? '!opacity-60' : ''
              } ${
                isActive
                  ? isSWApp
                    ? 'text-[var(--brand-color)]'
                    : `${isSFApp ? 'text-[#B7BECE]' : ''}`
                  : `${isSFApp ? 'text-white' : 'text-[#3D4256] opacity-70'}`
              }`}
            >
              {isSWApp && !show_package_price && <>By {pack.vendor.display_name}</>}
              {!hide_prices && (
                <>
                  {(!isSWApp || show_package_price) && (
                    <>
                      {!show_package_price ? 'Starting at ' : ''} ${formatPrice(pack.price)}/mo
                    </>
                  )}
                </>
              )}
            </div>
          )}
        </div>
      )}
      {minimal && (
        <div
          className={`${
            isActive
              ? `${isSFApp ? 'text-[#B7BECE]' : isStagedWithCortPackage(pack) ? 'text-white text-[14px] leading-[16px]' : 'text-[var(--brand-color)]'}`
              : `${isSFApp ? 'text-white' : 'text-[#3D4256]'}`
          } font-medium w-full text-center truncate`}
        >
          {getPackageName(pack)}
        </div>
      )}
      {/* {isActive && (
        <button
          type="button"
          className="absolute top-[8px] right-[8px] flex-shrink-0"
          onClick={() => {
            onInfoModalShow(pack)
          }}
        >
          <Info />
        </button>
      )} */}
    </button>
  )
}
export default Package
